/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let algoDataApiUrl = root.algoDataApiUrl.link;
let allUserAlgoDataApiUrl = root.allUserAlgoDataApiUrl.link;
let allPubAlgoDApiUrl = root.allPubAlgoDApiUrl.link;
let algoDataForModelTrainedApiUrl = root.algoDataForModelTrainedApiUrl.link;
let algoDataSharedApiUrl = root.algoDataSharedApiUrl.link;
let orgBasedPublicAlgoDataApiUrl = root.orgBasedPublicAlgoDataApiUrl.link;
let orgBasedPrivateAlgoDataApiUrl = root.orgBasedPrivateAlgoDataApiUrl.link;
let orgBasedDataListApiUrl = root.orgBasedDataListApiUrl.link;
let searchAlgoDataApiUrl = root.searchAlgoDataApiUrl.link;
let shareDatasetApiUrl = root.shareDatasetApiUrl.link;
let incomingSharedDatasetApiUrl = root.incomingSharedDatasetApiUrl.link;
let outgoingSharedDatasetApiUrl = root.outgoingSharedDatasetApiUrl.link;
let deleteDataListApiUrl =  root.deleteDataListApiUrl.link;
let dataDeleteApiUrl =  root.dataDeleteApiUrl.link;
let dataRestoreApiUrl =  root.dataRestoreApiUrl.link;

export default {
  state: {
    getAlgoDataListState:{},
    getAlgoDataDetailsState:{},
    getAllUserAlgoDataListState:{},
    getAllPubAlgoDataListState:{}
    },
  mutations: {
    getAlgoDataListMutation(state, value) {
      Vue.set(state, 'getAlgoDataListState', value);
    },
    getAlgoDataByIdMutation(state, value) {
      Vue.set(state, 'getAlgoDataDetailsState', value);
    },
    getAllUserAlgoDataListMutation(state, value) {
      Vue.set(state, 'getAllUserAlgoDataListState', value);
    },
    getAllPubAlgoDataListMutation(state, value) {
      Vue.set(state, 'getAllPubAlgoDataListState', value);
    },
  },
  actions: {
    deletedDataListAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.get(deleteDataListApiUrl + "?is_deleted=True").then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    dataDeleteByIdAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.post(dataDeleteApiUrl + "?id=" + payload.id).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    dataRestoreByIdAction(context, payload){
      return new Promise((resolve, reject) => {
        axios.post(dataRestoreApiUrl + "?id=" + payload.id).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    // Outgoing Shared Dataset List Action
    outgoingSharedDatasetListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(outgoingSharedDatasetApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Icoming Shared Dataset List Action
    icomingSharedDatasetListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(incomingSharedDatasetApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Share Dataset Action
    shareDatasetAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(shareDatasetApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Search Algo Data Action
    searchAlgoDataAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(searchAlgoDataApiUrl + '?search=' + payload.search + '&is_public=' + payload.state).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All Private Algo Data All List
    getPrivateAlgoDataBasedOrgAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(orgBasedPrivateAlgoDataApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All Public Algo Data All List
    getPublicAlgoDataBasedOrgAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(orgBasedPublicAlgoDataApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All User Algo Data All List
    getAllAlgoDataBasedOrgAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(orgBasedDataListApiUrl + '?area_of_work=' + payload.org + '&is_public=' + payload.state).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Algo Data Shared With User
    algoDataSharedWithUserAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(algoDataSharedApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All User Algo Data All List
    getAllAlgoDataForModelTrainedAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(algoDataForModelTrainedApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All User Algo Data All List
    getAllPubAlgoDataListByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(allPubAlgoDApiUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All User Algo Data All List
    getAllPubAlgoDataListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(allPubAlgoDApiUrl).then(res => {
              context.commit('getAllPubAlgoDataListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All User Algo Data All List
    getAllUserAlgoDataListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(allUserAlgoDataApiUrl).then(res => {
              context.commit('getAllUserAlgoDataListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Algo Data All List
    getAlgoDataListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(algoDataApiUrl).then(res => {
              context.commit('getAlgoDataListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Algo Data Details By Id
    getAlgoDataDetailsByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(algoDataApiUrl + payload.id + '/').then(res => {
              context.commit('getAlgoDataByIdMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    createAlgoDataDetailsAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(algoDataApiUrl,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    updateAlgoDataDetailsByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(algoDataApiUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    }
  },
  getters: {
    getMyAlgoDataListGetters: state => state.getAlgoDataListState,
    getAlgoDataDetailsGetters: state => state.getAlgoDataDetailsState,
    getAllUserAlgoDataListGetters: state => state.getAllUserAlgoDataListState,
    getAllPubAlgoDataListGetters: state => state.getAllPubAlgoDataListState,
  }
}